import api from "../services/admin_api_global";

// ── Leads ──
export const fetchLeads    = (params)   => api.get("/admin/leads", { params });
export const fetchLeadById = (id)       => api.get(`/admin/leads/${id}`);
export const createLead    = (data)     => api.post("/admin/leads", data);
export const updateLead    = (id, data) => api.patch(`/admin/leads/${id}`, data);
export const linkUser      = (id, userId) => api.patch(`/admin/leads/${id}/link-user`, { userId });

// ── Registered Users ──
export const fetchRegisteredUsers = (search) =>
  api.get("/admin/leads/registered-users", { params: search ? { search } : {} });

// ── Follow-ups ──
export const addFollowUp  = (leadId, data)             => api.post(`/admin/leads/${leadId}/followups`, data);
export const editFollowUp = (leadId, followUpId, data) => api.patch(`/admin/leads/${leadId}/followups/${followUpId}`, data);

// ── Demo ──
export const scheduleDemo     = (leadId, data) => api.post(`/admin/leads/${leadId}/demo`, data);
export const rescheduleDemo   = (leadId, data) => api.post(`/admin/leads/${leadId}/demo/reschedule`, data);
export const updateDemoStatus = (leadId, to)   =>
  api.patch(`/admin/leads/${leadId}/demo/status`, null, { params: { to } });
